// extracted by mini-css-extract-plugin
export var aiStarIcon = "_bg-4";
export var closeButton = "_bg-6";
export var dismissButton = "_bg-3";
export var editImageWithAiContainer = "_bg-8";
export var imageUploadWrapper = "_bg-7";
export var misspelledWord = "_bg-5";
export var spellCheckContainer = "_bg-2";
export var spin = "_bg-1";
export var spinning = "_bg-0";